import { Api } from '@/api'
const state = {
    classifyList: [],
    reportDetailId: '',
    uId: '',
    orgId: ''
  }
  const mutations = {
    setClassifyList(state, value) {
      state.classifyList = value
    },
    setOrgId(state, value) {
      state.orgId = value
    },
  }
  const actions = {
    // 获取分类列表
    getClassifyList({ commit, dispatch }) {
        return Api.classifyList({}).then(res => {
          if (res && res.code === '0') {
            commit('setClassifyList', res.data || [])
          } else {
            commit('setClassifyList', [])
          }
        })
      },
    // 获取orgId
    getListProject({ commit, dispatch }) {
        return Api.listProject({}).then(res => {
          if (res && res.success) {
            commit('setOrgId', res.data?.[0].projectId || '')
          } else {
            commit('setOrgId', '')
          }
        })
      }
  }
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  
  